const freeSampleProductsWufooMapping = {
  "urine-conditioning-buffer":
  {
  url:"https://zymoresearch.wufoo.com/forms/ws1havl0qhb7h3/"
  },
  "zymoclean-gel-dna-recovery-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w10fmu8j0j7lff4/"
  },
  "dna-clean-concentrator-5":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1p5d1kg0a6kw05/"
  },
  "genomic-dna-clean-concentrator-10":
  {
  url:"https://zymoresearch.wufoo.com/forms/w2leil91hgz4ep/"
  },
  "zyppy-plasmid-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wasx93f0f0o7wn/"
  },
  "quick-dna-miniprep-plus-dna-extraction-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wumxwfa04j9li8/"
  },
  "select-a-size-dna-clean-concentrator-magbead-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wxrzdgv1kxj5ho/"
  },
  "zymopure-ii-plasmid-midiprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1uh1po20cr5raa/"
  },
  "zymopure-ii-plasmid-maxiprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wib6xqn1biiwym/"
  },
  "zymopure-ii-plasmid-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1ex5zvj1rv3rie/"
  },
  "zymobiomics-dna-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w15ugn410qpaj7e/",
  trkTag: "WF_ZymoBIOMICS-DNA-Miniprep_Product-Page",
  },
  "ez-dna-methylation-lightning-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w12nhp0b1u59mem/"
  },
  "quick-dna-fungal-bacterial-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1jhp8q51o8mitp/"
  },
  "quick-dna-fecal-soil-microbe-dna-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wv4y0aj03pndfa/"
  },
  "quick-dna-plant-seed-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w9h1apf0bfgebo/"
  },
  "onestep-pcr-inhibitor-removal-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1let7jq0a75o4t/"
  },
  "onestep-pcr-inhibitor-removal-new-kit":
  {
  url: "https://zymoresearch.wufoo.com/forms/pdu6xo31m8427m/"
  },
  "zymolyase-ultra":
  {
  url:"https://zymoresearch.wufoo.com/forms/w12rq6v10jb3uuu/"
  },
  "dnase-i-set":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1pjsvop15boaa0/"
  },
  "purerec-rnase-a-recombinant":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1z0vnyi0c72dno/"
  },
  "rna-clean-concentrator-5":
  {
  url:"https://zymoresearch.wufoo.com/forms/wkrh1ce0a9vwdt/",
  trkTag: "WF_RCC-5_Product-Page",
  },
  "quick-rna-viral-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wyzwkd1jhxlyt/"
  },
  "quick-rna-microprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1m5ypds1ibn29o/"
  },
  "quick-rna-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wjbwd4q1c2cjnf/",
  trkTag: "WF_Quick-RNA-Miniprep_Product-Page",
  },
  "quick-rna-miniprep-plus-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/we3nrzi1rpp0ph/"
  },
  "dna-rna-shield":
  {
  url:"https://zymoresearch.wufoo.com/forms/w19cwh8v1pzwifn/"
  },
  "dna-rna-shield-fecal-collection-tube":
  {
  url:"https://zymoresearch.wufoo.com/forms/w18j3ojq1ja2a4k/"
  },
  "dna-rna-shield-lysis-and-collection-tubes":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1hptxbn1hai7eo/"
  },
  "dna-rna-shield-collection-tube-w-swab":
  {
  url:"https://zymoresearch.wufoo.com/forms/wlbf56c00tf9iw/"
  },
  "dna-rna-shield-fecal-collection-tube":
  {
  url:"https://zymoresearch.wufoo.com/forms/wzqijfy0vy3q4v/"
  },
  "bunny-wipe-fecal-sample-collector":
  {
  url:"https://zymoresearch.wufoo.com/forms/wgrc5u404df8wd/"
  },
  "dna-rna-shield-blood-collection-tube":
  {
  url:"https://zymoresearch.wufoo.com/forms/ws0etk00volhsn/"
  },
  "dna-rna-shield-safecollect-swab-collection-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wpc1nce1ogarc6/"
  },
  "dna-rna-shield-fecal-collection-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w12ndy4v025kdum/"
  },
  "dna-rna-shield-safecollect-saliva-collection-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1eqa77s1cp653v/"
  },
  "zymobiomics-rna-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1qfx0ej0yd0ycj/"
  },
  "zymobiomics-dna-rna-miniprep-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wz9n26w11ivbi2/"
  },
  "direct-zol-rna-miniprep-kits":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1gh1efe085ig5d/"
  },
  "direct-zol-rna-microprep-kits":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1q550c11v4xgzo/",
  trkTag: "WF_Direct-zol-Miniprep",
  },
  "mix-and-go-competent-cells-dh5-alpha":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1yov8d31scwlaq/",
  trkTag: "WF_Mix-Go-Competent-Cells-DH5-Alpha_Product-Page",
  },
  "purerec-duplex-specific-nuclease-dsn":
  {
  url:"https://zymoresearch.wufoo.com/forms/w1js1msw03npsas/"
  },
  "safecollect-skin-collection-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/wfbj8bm07986x9/"
  },
  "magicbead-cfdna-isolation-kit":
  {
  url:"https://zymoresearch.wufoo.com/forms/s1wsxs9l0illnu6/"
  },
};
